import React from "react";
import {html_content} from "./TermsAndConditions"
const myHTML = `<h1>John Doe</h1>`;

export default function App () {
    return (
        <div dangerouslySetInnerHTML={{ __html: html_content }} />
    )
};